var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoServe1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 132,
    viewBox: "0 0 295 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.8482L0 0C1.22725 30.4272 0.458315 104.893 0.920437 112.599C1.38066 120.273 10.585 131.122 21.6303 131.178C101.708 131.582 264.55 132.806 274.75 131.178C284.875 129.563 293.159 119.061 295 113.81V0L276.131 22.9327C275.978 49.7248 276.619 103.971 276.131 106.54C275.671 108.964 271.682 112.464 269.228 113.81C191.297 113.81 33.8582 114.176 27.6131 113.81C20.7098 113.407 18.869 107.887 18.4087 104.925L18 21.8482Z",
    fill: "#303183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoServe1);
export default __webpack_public_path__ + "static/media/who_serve_1.a5137a27dd53be9ae52294c3b37b1f21.svg";
export { ForwardRef as ReactComponent };